import angular from 'angular';

import Component from './portalPanel.component';
import './portalPanel.component.scss';

export default angular
  .module('petrocloud.dashboard.portalPanel', [])
  .component(Component.name, Component)
  .name;
